export default __webpack_public_path__ + "static/media/srectr-catalogue.874bab7b.png";